/* eslint no-template-curly-in-string: ['off'] */
import { Predicate } from '@syncfusion/ej2-data';
import { Selector } from '@felicity/data-management';
import AssistantDataSource from '../data/AssistantDataSource.mjs';

/**
 * Drop down list for selecting a single assistant user
 */
export default class AssistantSelector extends Selector {
  textField = 'name';
  valueField = 'id';
  groupByField = 'role';

  /* eslint class-methods-use-this: ['off'] */
  prepareFilter = (text, query) => {
    const predicate = new Predicate('name', 'contains', text, true)
      .or('role', 'startsWith', text, true);

    return query.where(predicate);
  };

  constructor() {
    super();

    this.dataSource = AssistantDataSource.getDataSource();
  }
}
